module.exports = __webpack_public_path__ + "media/images/webpage/hotels/model_cases/family_senior-b3cb4691857ff6553317aabe2c7e7a39.webp";